import axios from "axios";
import Auth from "../common/Auth";

function getKhachHangKhaoSat(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/thongke/khachhangkhaosat");
};
function getChiTietKhachHangKhaoSat(id){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/thongke/khachhang?id="+id);
};
function getUrlPage(listQuyen, roleUser) {
  if (Auth.checkUrl("/cus/thongke/khachhangkhaosat/**", listQuyen, roleUser)) {
      return process.env.REACT_APP_URL_SERVER + "/cus/thongke/khachhangkhaosat/getpage";
  }
  else return process.env.REACT_APP_URL_SERVER + "/cus/personal/thongke/khachhangkhaosat/getpage";
  

};
function getUrlSearch(key, listQuyen, roleUser) {
  if (Auth.checkUrl("/cus/thongke/khachhangkhaosat/**", listQuyen, roleUser)) {
      return process.env.REACT_APP_URL_SERVER + "/cus/thongke/khachhangkhaosat/search?key=" + key+"&";
  } else return process.env.REACT_APP_URL_SERVER + "/cus/personal/thongke/khachhangkhaosat/search?key=" + key +"&";

};


const ThongKeService={
  getKhachHangKhaoSat,
  getChiTietKhachHangKhaoSat,
  getUrlPage,
  getUrlSearch
};
export default ThongKeService;
